<template>
	
	<div class="">
		<!-- 机房门禁是否开启开关 -->
		<!-- 开启和禁用传递的参数0和3不能确定怎么互相对应，需数据库获取 -->
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">门禁开关管理</h1>
			<div class="text-left marBottom20">
				<el-button class="btn btn-primary" @click="clickSelectItem('启用')">批量启用</el-button>
				<el-button class="btn btn-primary danger" @click="clickSelectItem('禁用')">批量禁用</el-button>
			</div>
			
			<el-table
			stripe
			border
			:data="tableData"
			@selection-change="handleSelectionChange"
			style="width: 100%">
				<el-table-column
			      type="selection"
			      width="55">
			    </el-table-column>
				
				<el-table-column
					prop="tag"
					label="门禁名称">
				</el-table-column>
				<el-table-column
					prop="equipment_staus"
					label="联网状态">
				</el-table-column>
				
				<el-table-column
					prop="door_status"
					:formatter="doorSwitchFormat"
					label="是否启用">
				</el-table-column>
				
				<el-table-column
				label="操作">
				<template slot-scope="scope">
					<el-button type="text" size="small"
							@click="showChange(scope.row)">{{formatBtnValue(scope.row)}}
					</el-button>

					
				</template>
				</el-table-column>
			</el-table>
			
		</div>
		<!--批量确认弹框-->
		<el-dialog title="提示：" :visible.sync="flag2" width="500px" >
		    <div class="userInfo">
				<p>批量更改启用状态后会影响所选门禁是否启用门禁开关的状态<br/>
					您确认要批量修改状态吗？</p>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="flag2 = false">取消</el-button>
			    <el-button type="primary" @click="confirmBatchOpe()">确认</el-button>
			  </div>
		</el-dialog>
		<!--单个确认弹框-->
		<el-dialog title="提示：" :visible.sync="flag1" width="500px" >
		    <div class="userInfo">
				<p>更改启用状态后会影响是否启用门禁开关的状态<br/>
					您确认要修改状态吗？</p>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="flag1 = false">取消</el-button>
			    <el-button type="primary" @click="confirmChange()">确认</el-button>
			  </div>
		</el-dialog>
	</div>
</template>
<script>
export default {
  name: 'app',
  data(){
    return {
		tableData: [],
		// 控制是否启用默认值
		changeStatusNum: 3,
		changeMac: "",
		// 单个删除弹框
		flag1: false,
		// 批量处理类型
		batchCurrent: 1,
		startNum: 1,
		forbidNum: 1,
		// 批量弹框
		flag2: false,
		// 批量MAC地址
		batchSmart_mac: "",
//  	多选时选中选项
		multipleSelection:[],
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.getDetail();
  	})
  },

  methods: {
	getDetail(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Doorctlfan/List",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.tableData = res.data.data || [];
				if(this.tableData.length){
					this.startNum = this.tableData[0].logic_open_value;
					this.forbidNum = this.tableData[0].logic_close_value;
				}
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	// 如果当前启用，则按钮为禁用；反之则启用
	formatBtnValue(row){
		if(row.door_status==row.logic_close_value){
			return "启用";
		}else if(row.door_status==row.logic_open_value){
			return "禁用";
		}else{
			return "";
		}
	},
	showChange(row){
		this.flag1 = true;
		this.changeMac = row.smart_mac||"";
		if(row.door_status && row.door_status==3){
			this.changeStatusNum = 0;
		}else{
			this.changeStatusNum = 3;
		}
		
	},
	confirmChange(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			mac_address: this.changeMac || "",
			current: this.changeStatusNum,
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Doorctlfan/ctl",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				
				this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
		let self = this;
		setTimeout(function(){
			self.getDetail();
		},5000)
		
		this.flag1 = false;
	},
	handleSelectionChange(val){
		this.multipleSelection = val
	},
	// 点击删除跳出批量删除弹框
	clickSelectItem(type){
		if(type=='启用'){
			this.batchCurrent = this.startNum;
		}else{
			this.batchCurrent = this.forbidNum;
		}
		if(this.multipleSelection.length>0){
			var obEditAlarmUserIdArr = [];
			for (let i = 0; i < this.multipleSelection.length; i++) {
				obEditAlarmUserIdArr.push(this.multipleSelection[i].smart_mac);
			}
			this.batchSmart_mac = JSON.stringify(obEditAlarmUserIdArr).replace(/\[|]|"|"/g,'')
			this.flag2 = true;
			
		}else{
			this.$message.error("请选择批量处理的对象！");
		}
		
	},

	confirmBatchOpe(){
		
		
		let valiCodeParams={
			uid:this.getCookie('uid'),
			mac_address: this.batchSmart_mac || "",
			current: this.batchCurrent,
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Doorctlfan/batch_ctl",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				
				this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
		let self = this;
		setTimeout(function(){
			self.getDetail();
		},5000)
		this.flag2 = false;
	}

	
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/doorSwitch.vue